import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { trackEventPayload } from "@src/util/track-event-payload";
import { Form, InputNumber } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import { useTracking } from "react-tracking";

export const MaxDayDiffFilter: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { trackEvent } = useTracking();
  return (
    <Form.Item
      className="mx-1"
      label="Max Day diff"
      name={FilterFormFieldsEnum.MAX_DAY_DIFF}
      required
      rules={[
        {
          message: "Please select a max day diff",
          required: true,
        },
      ]}
    >
      <InputNumber
        min={0}
        placeholder="Select max day diff"
        style={{
          width: 100,
        }}
        onChange={(value) => {
          trackEvent(trackEventPayload.generalInfoFieldUpdated({ name: "day_diff", value: value }));
        }}
      />
    </Form.Item>
  );
};
